import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.set-po-bill-to-settings.views.po-bill-to-settings-card`

export default defineMessages({
  primaryCategoryFieldLabel: {
    id: `${scope}.primaryCategoryFieldLabel`,
    defaultMessage: 'Bill to {singularPrimaryOrgCategoryLabel}',
  },
  purchaserHomePrimaryCategoryOption: {
    id: `${scope}.purchaserHomePrimaryCategoryOption`,
    defaultMessage:
      "Purchaser's home {singularPrimaryOrgCategoryLabel} (the final approver's home {singularPrimaryOrgCategoryLabel} on automatic POs)",
  },
  orderPrimaryCategoryOption: {
    id: `${scope}.orderPrimaryCategoryOption`,
    defaultMessage:
      "Order's {singularPrimaryOrgCategoryLabel} (comes from the first line item)",
  },
  headquartersPrimaryCategoryOption: {
    id: `${scope}.headquartersPrimaryCategoryOption`,
    defaultMessage: 'Headquarters {singularPrimaryOrgCategoryLabel}',
  },
  contactFieldLabel: {
    id: `${scope}.contactFieldLabel`,
    defaultMessage: 'Bill to contact',
  },
  purchaserContactOption: {
    id: `${scope}.purchaserContactOption`,
    defaultMessage: 'Purchaser',
  },
  requesterContactOption: {
    id: `${scope}.requesterContactOption`,
    defaultMessage: 'Requester',
  },
  specificUserContactOption: {
    id: `${scope}.specificUserContactOption`,
    defaultMessage: 'Specific user',
  },
  accountsPayableContactOption: {
    id: `${scope}.accountsPayableContactOption`,
    defaultMessage: 'Accounts payable',
  },
  contactUserFieldLabel: {
    id: `${scope}.contactUserFieldLabel`,
    defaultMessage: 'Bill to contact user',
  },
  contactUserFieldPlaceholder: {
    id: `${scope}.contactUserFieldPlaceholder`,
    defaultMessage: 'Select a user',
  },
  contactUserRequiredError: {
    id: `${scope}.contactUserRequiredError`,
    defaultMessage: 'Select a user to be the bill to contact',
  },
})
